import * as React from 'react';
import type { SVGProps } from 'react';
const SvgConfetti = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={25}
    fill="none"
    viewBox="0 0 25 25"
    {...props}
  >
    <path
      fill="#FCB833"
      d="M10.75 5.273a1.348 1.348 0 0 0-2.22.494L3.403 19.87a1.35 1.35 0 0 0 1.261 1.81c.159 0 .317-.029.466-.083l14.1-5.127a1.347 1.347 0 0 0 .488-2.22zM4.73 20.495a.174.174 0 0 1-.225-.225l1.482-4.079 2.822 2.82zm5.293-1.925L6.43 14.976l1.432-3.94 6.103 6.102zm8.922-3.329a.17.17 0 0 1-.111.127L15.18 16.7 8.3 9.82l1.332-3.648a.17.17 0 0 1 .127-.111.2.2 0 0 1 .04 0 .17.17 0 0 1 .122.051l8.973 8.973a.17.17 0 0 1 .051.157m-3.125-8.21c.014-.498.135-.986.355-1.433.482-.965 1.396-1.496 2.575-1.496.73 0 1.224-.268 1.512-.819.146-.293.23-.612.246-.94a.586.586 0 1 1 1.172 0c0 1.014-.613 2.93-2.93 2.93-.73 0-1.224.268-1.512.819-.146.292-.23.612-.246.94a.586.586 0 1 1-1.172 0m-2.343-3.125V1.563a.586.586 0 1 1 1.171 0v2.343a.586.586 0 1 1-1.171 0m9.593 8.18a.59.59 0 0 1 .015.843.586.586 0 0 1-.843-.015l-1.562-1.562a.586.586 0 0 1 .828-.829zm.553-4.5-2.344.782a.586.586 0 1 1-.37-1.111l2.343-.781a.586.586 0 0 1 .371 1.11"
    />
  </svg>
);
export default SvgConfetti;
